
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinnigdii() {



    const cardData =
    {
        keyword: 'Cab Service in Nigdi',
        heading: 'Platinum24 Cabs: Cab Service in Nigdi',
        headingDescription: ' Platinum24 Cabs provides reliable Cab Service in Nigdi, designed to meet the travel needs of families, professionals, and corporate clients. Whether it’s a local ride within Pimpri-Chinchwad, an airport transfer, or an outstation journey, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable experience. With professional drivers, clean vehicles, and transparent pricing, we make every trip hassle-free. From quick daily commutes to long-distance travel, Platinum24 Cabs guarantees punctual service, affordability, and customer satisfaction for passengers across Nigdi and nearby areas.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


     "services": [
    {
      "name": "Nigdi Cab Service",
      "description": "Experience dependable and comfortable travel with our Nigdi Cab Service, catering to both residents and visitors seeking convenient transportation around the area. Our fleet consists of well-maintained vehicles equipped with modern amenities to ensure a smooth and enjoyable ride. Whether it’s a quick trip to the market, a business appointment, or a leisurely city tour, our professional drivers prioritize your safety, punctuality, and comfort. With easy booking options available via phone or online, transparent pricing with no hidden fees, and 24/7 customer support, traveling in Nigdi has never been easier or more reliable."
    },
    {
      "name": "Taxi Service Nigdi",
      "description": "Our Taxi Service Nigdi is designed to meet all your travel needs, whether local or outstation. Offering a diverse range of vehicles from economical compact cars to spacious SUVs, we cater to individuals, families, and groups of any size. Our courteous and experienced drivers know the local routes and traffic patterns well, ensuring you reach your destination safely and on time. From daily commutes to airport transfers and city tours, our taxi service combines affordability, reliability, and convenience. Real-time GPS tracking and easy online booking make your travel planning hassle-free."
    },
    {
      "name": "Nigdi Local Taxi",
      "description": "For fast and convenient rides within Nigdi, our Nigdi Local Taxi service is your go-to option. Whether running errands, attending appointments, or visiting local attractions, our taxis offer quick pickups, affordable fares, and comfortable seating. Our drivers are well-versed in the best routes to avoid traffic delays, making your city travel efficient and stress-free. Vehicles are regularly sanitized and equipped with amenities like air conditioning for a pleasant experience. Booking is easy through our app or hotline, providing flexible options suited to your schedule."
    },
    {
      "name": "Affordable Taxi Nigdi",
      "description": "Travel smart with our Affordable Taxi Nigdi service, designed to offer cost-effective transportation without sacrificing quality or comfort. Perfect for budget-conscious customers, our fleet features fuel-efficient vehicles that deliver great mileage and reduced environmental impact. Enjoy transparent fare structures with no hidden charges, plus special discounts on early bookings and loyalty rewards. Whether you need a taxi for a short ride or an extended trip, we offer flexible rental options and professional drivers who ensure a safe and pleasant journey."
    },
    {
      "name": "Nigdi Taxi with Driver",
      "description": "Enjoy the luxury of having a professional driver at your service with our Nigdi Taxi with Driver option. Our drivers are thoroughly trained, courteous, and familiar with the local and surrounding routes, guaranteeing a smooth and stress-free ride. Ideal for business travelers, tourists, families, and elderly passengers, this service provides comfort, convenience, and peace of mind. Vehicles are regularly cleaned and sanitized, and drivers adhere to strict safety protocols. Flexible hourly or daily packages are available to suit your specific travel needs."
    },
    {
      "name": "Nigdi Airport Taxi",
      "description": "Never worry about airport transfers again with our reliable Nigdi Airport Taxi service. Offering timely pickups and drop-offs to Pune Airport and other regional terminals, our drivers monitor flight statuses to adjust your schedule accordingly, minimizing waiting times. Our vehicles are spacious and luggage-friendly, providing ample room for your bags and companions. Fixed fares ensure you know the cost upfront, with no surprises. Whether traveling solo or with a group, our airport taxi service prioritizes punctuality, comfort, and safety for a hassle-free start or end to your journey."
    },
    {
      "name": "Cab Rental Nigdi",
      "description": "Rent a cab in Nigdi with ease through our flexible Cab Rental Nigdi service. Choose from a variety of vehicle types — from compact cars for city drives to larger SUVs for group outings or family trips. Rentals can be hourly, daily, or long-term, with options for self-drive or chauffeur-driven vehicles. All our cabs undergo rigorous maintenance and sanitization to ensure your safety and comfort. Our transparent pricing model, combined with an easy booking process and responsive customer service, makes cab rental a convenient and trustworthy option for your transportation needs."
    },
    {
      "name": "Nigdi Outstation Taxi",
      "description": "Plan your intercity travel with confidence using our Nigdi Outstation Taxi service. Whether it's a weekend getaway, a business trip, or visiting friends and family, our clean and comfortable taxis offer a stress-free journey. Our drivers are experienced in long-distance travel, knowledgeable about highway routes, tolls, and rest stops to make your ride safe and enjoyable. Transparent pricing includes tolls and fuel charges, and we provide customizable packages to fit your itinerary and budget. Door-to-door service and 24/7 support ensure a smooth travel experience."
    },
    {
      "name": "Nigdi Corporate Taxi",
      "description": "Enhance your corporate travel with our Nigdi Corporate Taxi service, tailored to meet business needs with professionalism and efficiency. Whether for daily employee commutes, client pickups, or executive transportation, we provide punctual, comfortable rides with well-maintained vehicles and trained drivers. Our service includes monthly billing, GST invoicing, and customizable plans that fit your organization's requirements. Dedicated account managers ensure seamless communication and quick resolution of any travel concerns, helping your business maintain productivity and professionalism."
    },
    {
      "name": "Nigdi Taxi Deals",
      "description": "Save more with our exclusive Nigdi Taxi Deals, designed to offer budget-friendly travel without compromising on service quality. Benefit from seasonal discounts, early booking offers, weekend specials, and referral rewards. Our transparent pricing policy ensures no hidden fees, giving you peace of mind with every ride. Whether booking for local trips or long-distance travel, these deals provide excellent value. Join our loyalty program to accumulate points and enjoy further discounts, making your frequent travels even more affordable."
    },
    {
      "name": "Nigdi City Taxi",
      "description": "Navigate Nigdi with ease using our Nigdi City Taxi service, ideal for locals and visitors looking for reliable city transportation. Our taxis are equipped with GPS navigation and safety features to ensure timely and secure rides. Whether you need transportation for daily errands, business meetings, or sightseeing, our courteous drivers offer professional and friendly service. Flexible booking options, competitive fares, and on-time pickups make city travel smooth and enjoyable. Our customer support team is always available to assist with special requests or travel planning."
    },
    {
      "name": "Nigdi Family Taxi Service",
      "description": "Travel comfortably with your loved ones using our Nigdi Family Taxi Service. Spacious vehicles provide ample room for family members and luggage, perfect for outings, functions, or sightseeing tours. Safety is a priority — child seats and other special accommodations can be arranged upon request. Our drivers are patient, experienced, and friendly, ensuring a pleasant journey for passengers of all ages. Booking is hassle-free through our app or phone, with flexible scheduling options and affordable pricing tailored for family needs."
    },
    {
      "name": "Taxi Booking Online Nigdi",
      "description": "Book your taxi quickly and conveniently with Taxi Booking Online Nigdi, a user-friendly platform that enables instant reservations anytime, anywhere. Select your vehicle type, pickup and drop-off locations, and rental duration with just a few clicks. Our secure payment gateway supports multiple payment methods for hassle-free transactions. Receive instant confirmation and real-time updates on your booking status. Our 24/7 customer support team is always available to assist with changes, cancellations, or special requests, making your travel planning seamless and stress-free."
    },
    {
      "name": "Nigdi Taxi Service 24x7",
      "description": "No matter the hour, our Nigdi Taxi Service 24x7 is here to serve your transportation needs around the clock. Whether you require an early morning airport transfer, late-night ride, or emergency taxi service, our reliable fleet and professional drivers are ready to assist. We prioritize your safety, punctuality, and comfort with fast response times and flexible booking options. Enjoy peace of mind knowing that support is just a call or click away, with dedicated customer service available 24/7 to ensure your journey is smooth from start to finish."
    }
  ],
  "tableData": [
    ["Nigdi Cab Service", "Taxi Service Nigdi"],
    ["Nigdi Local Taxi", "Affordable Taxi Nigdi"],
    ["Nigdi Taxi with Driver", "Nigdi Airport Taxi"],
    ["Cab Rental Nigdi", "Nigdi Outstation Taxi"],
    ["Nigdi Corporate Taxi", "Nigdi Taxi Deals"],
    ["Nigdi City Taxi", "Nigdi Family Taxi Service"],
    ["Taxi Booking Online Nigdi", "Nigdi Taxi Service 24x7"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Cab Service in Nigdi",
    "WhyChoosedescription": "Platinum24 Cabs offers reliable and affordable cab services in Nigdi for all your local travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Well-Maintained Vehicles",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to suit your group size and preferences."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Your Safety",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to ensure a safe and comfortable ride in Nigdi."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Nigdi Area",
    "WhyChoosedescription": "Our professional drivers know Nigdi’s routes well to provide smooth and timely travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares that include fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated team is available round the clock to assist you with cab bookings in Nigdi."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long Term",
    "WhyChoosedescription": "Choose hourly, daily, or long-term rental plans tailored to your travel requirements."
  },
  {
    "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
    "WhyChoosedescription": "Book your Nigdi cab quickly and securely through our website or app with real-time confirmation."
  }
]















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Nigdi?',
        answer: 'Yes, Platinum24 Cabs provides reliable and efficient cab services in Nigdi for all your travel needs.',
    },
    {
        question: 'How can I book a cab service in Nigdi with Platinum24 Cabs?',
        answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for cab service in Nigdi?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your preferences.',
    },
    {
        question: 'Can I use the cab service in Nigdi for local and outstation travel?',
        answer: 'Yes, Platinum24 Cabs offers cab services for both local trips within Nigdi and outstation travel.',
    },
    {
        question: 'Are the drivers experienced and familiar with Nigdi routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and knowledgeable about Nigdi and nearby areas.',
    },
    {
        question: 'Is hourly and daily cab service available in Nigdi?',
        answer: 'Yes, we provide flexible hourly and daily cab packages tailored to your travel plans.',
    },
    {
        question: 'Are safety and hygiene protocols followed for cabs in Nigdi?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety measures to ensure passenger safety.',
    },
    {
        question: 'Is cab service in Nigdi available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab booking and services in Nigdi.',
    },
    {
        question: 'What payment options are accepted for cab bookings in Nigdi?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for seamless transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Nigdi for cab service?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Nigdi as per your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Abhijit Deshpande',
        feedback: 'The cab service in Nigdi by Platinum24 Cabs was punctual, safe, and very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Jadhav',
        feedback: 'Highly recommend Platinum24 Cabs for reliable and friendly cab service in Nigdi.',
        rating: 5,
    },
];






































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const nigdiCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab service in Nigdi offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver.",
  "areaServed": {
    "@type": "Place",
    "name": "Nigdi, Pune"
  },
  "serviceType": [
    "Nigdi Cab Service",
    "Taxi Service Nigdi",
    "Nigdi Local Taxi",
    "Affordable Taxi Nigdi",
    "Nigdi Taxi with Driver",
    "Nigdi Airport Taxi",
    "Cab Rental Nigdi",
    "Nigdi Outstation Taxi",
    "Nigdi Corporate Taxi",
    "Nigdi Taxi Deals",
    "Nigdi City Taxi",
    "Nigdi Family Taxi Service",
    "Taxi Booking Online Nigdi",
    "Nigdi Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Nigdi | Affordable Taxi Service Nigdi Pune</title>
  <meta
    name="description"
    content="Reliable and affordable cab service in Nigdi offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver."
  />
  <meta
    name="keywords"
    content="Nigdi Cab Service, Taxi Service Nigdi, Nigdi Local Taxi, Affordable Taxi Nigdi, Nigdi Taxi with Driver, Nigdi Airport Taxi, Cab Rental Nigdi, Nigdi Outstation Taxi, Nigdi Corporate Taxi, Nigdi Taxi Deals, Nigdi City Taxi, Nigdi Family Taxi Service, Taxi Booking Online Nigdi, Nigdi Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(nigdiCabServiceSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/84.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinnigdii;